import React from 'react';
import ReactCrop from 'react-image-crop';

import { getImageWithCrop, getImageWithMaxWidth } from '../global.js';

export default class ImageInput extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      object: this.props.object,
      properties: this.props.properties,
      infoLabel: null,
      initTime: Date.now(),
    };
  }

  handleChange = (e) => {
    let object = this.state.object;
    var properties = this.state.properties;
    var file = e.target.files[0];
    if (file && file.type.match(/image\/*/)) {
      var reader = new FileReader();
      reader.onload = (e) => {
        getImageWithMaxWidth(e.target.result, 960, (imageBase64) => {
          if (properties.type === "image") {
              object = {data: imageBase64, type: file.type};
          } else {
            object = {
              original_data: imageBase64, 
              data: imageBase64, 
              crop: {x: 0, y: 0, width: 100, height: 100}, 
              type: file.type
            };
          }
          this.setState({object: object});
          this.props.onChange(this.props.objectKey, object);
        });
      };
      reader.readAsDataURL(file);
    }
  }

  componentWillReceiveProps = (props) => {
    if (typeof props.object !== "undefined" && props.object !== null) {
      this.setState({object: props.object});
    }
  }

  handleRemoveClick = () => {
    this.fileInput.value = '';
    this.setState({object: ""});
    this.props.onChange(this.props.objectKey, "");
  }

  render = () => {
    var properties = this.state.properties;

    var removeButton = <input 
      type="button"
      onClick={this.handleRemoveClick}
      value="Удалить"
      className="btn button-remove-image"
    />

    if (properties.type === "image") {
      let imageUrl = this.state.object.data || this.state.object || null;
      if (this.props.disabled || !imageUrl || imageUrl.length === 0) {
        removeButton = null;
      }
      return (
        <div className="edit-image">
          <img src={imageUrl} alt="" />
          <input
            type="file"
            accept="image/*"
            onChange={this.handleChange}
            disabled={this.props.disabled}
            ref={(input) => {this.fileInput = input;}}
          />
          {removeButton}
        </div>
      )
    }
    
    if (properties.type === "image-crop") {
      let imageUrl = this.state.object.original_data
        || this.state.object.original_url
        || this.state.object.url
        || null;
      var cropper = null;
      if (this.props.disabled || !imageUrl || imageUrl.length === 0) {
        removeButton = null;
      }      
      if (imageUrl) {

        let infoLabel = null;
        if (this.state.infoLabel) {
          infoLabel = <div className="infoLabel" style={this.state.infoLabel.style}>
            {this.state.infoLabel.text}
          </div>
        }

        if (!this.state.object.original_data) {
          imageUrl += "?t=" + this.state.initTime;
        }
        var crop = null;
        if (!this.props.disabled) {
          crop = this.state.object.crop || {x: 0, y: 0, width: 100, height: 100};
        }
        cropper = <ReactCrop 
          src={imageUrl}
          crossorigin={"Anonymous"}
          keepSelection={true}
          disabled={this.props.disabled}
          crop={crop}
          onChange={(crop, pixelCrop) => {
            let topPos = (crop.y + crop.height);
            let leftPos = (crop.x + crop.width);
            let style = {
              top: "calc(" + topPos + "% + " + (topPos < 90 ? "10" : "-40") + "px)",
              left: "calc(" + leftPos + "% - 80px)",
            };
            let text = pixelCrop.width + " x " + pixelCrop.height;
            this.setState({infoLabel: {text: text, style: style}});
          }}
          onComplete={(crop, pixelCrop) => {
            if (!this.state.original_url && !this.state.original_data) {
              getImageWithCrop(imageUrl, null, (imageData) => {
                var object = this.state.object;
                object.original_data = imageData;
                this.setState({object: object});
              });
            }
            getImageWithCrop(imageUrl, pixelCrop, (imageData) => {
              var object = this.state.object;
              object.crop = crop;
              object.data = imageData;
              this.setState({object: object});
            });
          }}
        >
          {infoLabel}
        </ReactCrop>
      }

      return (
        <div>
          {cropper}
          <input
            type="file"
            accept="image/*"
            onChange={this.handleChange}
            disabled={this.props.disabled}
            ref={(input) => {this.fileInput = input;}}
          />
          {removeButton}
        </div>
      )
    }

  }
}



// WEBPACK FOOTER //
// ./src/input/ImageInput.js